import axios from 'axios'
import VueCookies from 'vue-cookies'
import nav from "./../containers/_nav";

export async function callApi(method, url, parameter = null, header = null, body = null) {
    return await axios({
            method,
            headers: header == null ? {} : header,
            data: body == null ? {} : body,
            url,
            params: parameter == null ? {} : parameter
        })
        .then(function(response) {
            let data = response.data
                // if (VueCookies.get('token')) {
                //   VueCookies.remove("token");
                //   // VueCookies.remove("shortProfile");
                //   // alert(data.detail)
                //   window.location.href = "/";
                // }
            return data;
        })
        .catch(error => {
            console.log(error)
            if (error.response && error.response.status === 401) {
                VueCookies.remove("token");
                alert("Login Timeout")
                window.location.href = "/";
            } else if (error.response && error.response.status === 403) {
                // axios({
                //         url: `${this.$baseUrl}/api/admin/permission`,
                //         method: "get",
                //         headers: this.$headers,
                //     })
                //     .then(async(response) => {
                //         // handle success
                //         if (response.data.result == 1) {
                //             let goto = "";
                //             nav[0]._children = await nav[0]._children.filter(
                //                 (x) => {
                //                     if (response.data.detail.indexOf(x.id) != -1) {
                //                         goto = x.to;
                //                         return;
                //                     }
                //                 }
                //             );
                //             window.location.href = goto;
                //             //this.$router.push({ path: goto });
                //         }
                //     })
                //     .catch(function(error) {
                //         // handle error
                //         console.log(error);
                //     })
                window.location.href = "/403"
            }
        })
}